// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chips-list[data-v-cdf3aaa4]{display:flex;grid-gap:10px;gap:10px;flex-wrap:wrap;max-height:100px;overflow-y:auto;padding:5px}.chips-list__chip[data-v-cdf3aaa4]{max-width:150px}.chips-list__chip[data-v-cdf3aaa4] .v-chip__content{display:block;overflow:hidden;text-overflow:ellipsis;height:auto}", ""]);
// Exports
module.exports = exports;
